import { useQuery } from '@tanstack/react-query';
import { useConnection } from 'wagmi';

import { QueryKeys } from '@/app/shared/constants/queryKeys';
import { getReferralInvitees } from '@/app/shared/services/api';
import { ReferralInviteeRow } from '@/app/shared/services/api/types';

export interface UseReferralInviteesReturn {
  rows: ReferralInviteeRow[];
  total: number;
  updatedAt: number | string | null;
  isLoading: boolean;
  refetch: () => void;
}

export const useReferralInvitees = (): UseReferralInviteesReturn => {
  const { address } = useConnection();

  const { data, isLoading, refetch } = useQuery({
    queryKey: [QueryKeys.REFERRAL_INVITEES, address],
    queryFn: () => getReferralInvitees({ address, page: 1, limit: 100 }),
    enabled: !!address,
  });

  return {
    rows: data?.rows ?? [],
    total: data?.total ?? 0,
    updatedAt: data?.updatedAt ?? null,
    isLoading,
    refetch,
  };
};
